import { Transform } from 'class-transformer';
import { IsBoolean, IsDateString, IsNotEmpty, IsOptional, IsString, MaxLength } from 'class-validator';
import { DeliveryAddressModel } from '../delivery-address.model';
import { OrderStatus } from '../orders/order-status.enum';
import { OrderType } from '../orders/order-type.enum';
import { RelatedOrderDto } from '../orders/related-order.dto';
import { OriginApp } from '../origin-app.enum';
import { ShippingSettingsModel } from '../shipping-settings.model';
import { extractPlainDate, sanitizeString } from '../utils';
import { DraftProductModel } from './draft-product.model';

// Todo: For the keys decorated with @IsOptional(), mark them as optional in the constructor with ?
export class DraftModel {
  @IsString()
  @IsNotEmpty()
  public id: string;

  @IsString()
  @IsNotEmpty()
  public orderNumber: string;

  @IsString()
  @IsNotEmpty()
  public accountId: string;

  @IsString()
  @IsNotEmpty()
  public userId: string;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  public currencyCode: string;

  @IsOptional()
  @IsNotEmpty()
  public date: Date | string;

  @IsDateString()
  @IsNotEmpty()
  @Transform(({ value }) => extractPlainDate(value))
  public dueDate: string;

  @IsNotEmpty()
  public type: OrderType;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  @MaxLength(20)
  @Transform(({ value }) => sanitizeString(value))
  public customerPoNumber: string;

  @IsOptional()
  @IsNotEmpty()
  public deliveryAddress?: DeliveryAddressModel;

  @IsOptional()
  @IsNotEmpty()
  public shippingSettings?: ShippingSettingsModel;

  @IsNotEmpty()
  public products: DraftProductModel[];

  @IsOptional()
  @IsNotEmpty()
  public subTotal?: number;

  @IsOptional()
  @IsNotEmpty()
  public total?: number;

  @IsOptional()
  @IsNotEmpty()
  public status: OrderStatus;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  public salesTaker: string;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  public contactId?: string;

  @IsOptional()
  @IsNotEmpty()
  public pricesAsync: boolean;

  @IsOptional()
  @IsNotEmpty()
  public origin: OriginApp;

  /**
   * Seasons array to which a draft belongs too.
   * For pre-orders, the array should normally contain just one value, given
   * atm there is never 2 pre-order seasons open at the same time.
   * ie. ['FW22', 'SS23']
   */
  @IsOptional()
  @IsNotEmpty()
  public seasons?: string[];

  /**
   * When creating multiple pre-orders, we should be able to group them using a groupId
   * @example '9a48e37a-e9f1-43e8-a1d4-a933ef1bbb8e'
   */
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  public groupId?: string;

  /**
   * Related drafts with a groupId when creating a multiple pre-order
   */
  @IsOptional()
  @IsNotEmpty()
  public relatedOrders?: RelatedOrderDto[];

  /**
   * Order number corresponding to the order from which this draft order was cloned/created.
   * Must be a sales order number or a draft order number
   * @example SO01B0041950U
   */
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  public sourceOrderNumber?: string;

  @IsOptional()
  @IsBoolean()
  public isCreatedViaExcelUpload?: boolean;
}
